import { render } from "./ConnectExternalProductModal.vue?vue&type=template&id=8cbfb4c8&scoped=true"
import script from "./ConnectExternalProductModal.vue?vue&type=script&lang=js"
export * from "./ConnectExternalProductModal.vue?vue&type=script&lang=js"

import "./ConnectExternalProductModal.vue?vue&type=style&index=0&id=8cbfb4c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbfb4c8"]])

export default __exports__